import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const SwotAntragEmobFundE: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Stärken, Schwächen, Chancen, Risiken, Herausforderungen' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0260019443_erungen_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0074298450_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0138451405_en_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0023299332_orderungen_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};
export default SwotAntragEmobFundE;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0023299332_orderungen_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0161607006_n_Herausforderungen_Staerken,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0002573470_Herausforderungen_Schwaechen,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0232496142_en_Herausforderungen_Chancen,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0221525118_en_Herausforderungen_Risiken,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0261577748_Herausforderungen_Im_Projekt,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

export const getFormStrucSwotAntragEmobFundE = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0260019443_erungen_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0023299332_orderungen_Pruefung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	else return concat(formStruc());
};
